import { createCpmsBoChargePointSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-charge-point.slice';

import { cpmsBoChargePointApi } from './cpms-bo-charge-point.service';

export const cpmsBoChargePointSlice = createCpmsBoChargePointSlice({
  cpmsBoChargePointApi,
});
